import type { FeatureFlagProvider } from './core/featureFlagClient.types';

export type FeatureFlagKind = 'boolean' | 'string' | 'number';

type FeatureFlagValueByKind = {
  boolean: boolean;
  string: string;
  number: number;
};

export type PortalFeatureFlagDefinition<
  Provider extends FeatureFlagProvider = FeatureFlagProvider,
  Kind extends FeatureFlagKind = FeatureFlagKind,
> = {
  readonly key: `frontend_portal_${string}`;
  readonly provider: Provider;
  readonly kind: Kind;
};

export type FeatureFlagValue<
  Definition extends PortalFeatureFlagDefinition<FeatureFlagProvider, FeatureFlagKind>,
> = FeatureFlagValueByKind[Definition['kind']];

export type PortalFeatureFlagRegistry = Record<
  string,
  PortalFeatureFlagDefinition<FeatureFlagProvider, FeatureFlagKind>
>;

export function definePortalFeatureFlag<
  const Provider extends FeatureFlagProvider,
  const Name extends string,
  const Kind extends FeatureFlagKind,
>(
  provider: Provider,
  name: Name,
  kind: Kind
): PortalFeatureFlagDefinition<Provider, Kind> & { readonly key: `frontend_portal_${Name}` } {
  return {
    key: `frontend_portal_${name}` as `frontend_portal_${Name}`,
    provider,
    kind,
  };
}
